import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck } from 'lucide-react';

const AboutUs = () => {


    return (
        <div className="bg-brand-card py-20 relative overflow-hidden">
            {/* Background Decoration */}
            <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-brand-bg rounded-full blur-3xl opacity-50 z-0"></div>
            <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-brand-bg rounded-full blur-3xl opacity-50 z-0"></div>

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                    {/* Left Content */}
                    <div>
                        <span className="inline-block px-4 py-1.5 rounded-full bg-brand-bg text-brand-gold font-semibold text-sm mb-4 border border-brand-gold uppercase tracking-wider">Who We Are</span>
                        <h2 className="text-3xl font-bold text-brand-textLight mb-6 leading-tight">
                            Empowering the Next Generation of Tech Leaders
                        </h2>
                        <p className="text-lg text-brand-textMuted mb-8 leading-relaxed">
                            AIGenius is a premier technology training institute dedicated to bridging the gap between academia and industry. We provide cutting-edge curriculum in Cloud Computing, DevOps, and Artificial Intelligence, designed by experts from FAANG companies.
                        </p>

                        <div className="space-y-4 mb-10">
                            {[
                                "Industry-aligned curriculum updated quarterly",
                                "Hands-on labs with real-world cloud environments",
                                "1:1 Mentorship from Senior Engineers"
                            ].map((item, index) => (
                                <div key={index} className="flex items-center">
                                    <div className="mr-3">
                                        <BadgeCheck className="w-6 h-6 text-black fill-gray-500" strokeWidth={2.5} />
                                    </div>
                                    <span className="text-brand-textLight font-medium text-lg">{item}</span>
                                </div>
                            ))}
                        </div>

                        <Link to="/about-us" className="inline-block px-8 py-4 bg-brand-card text-black font-bold rounded-lg shadow-lg hover:bg-brand-goldHover transition-all hover:-translate-y-1 text-center">
                            Learn More About Us
                        </Link>
                    </div>

                    {/* Right Image/Stats */}
                    <div className="relative mt-12">
                        <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white">
                            <img
                                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                                alt="Team collaboration"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                            <div className="absolute bottom-6 left-6 right-6 text-black">
                                <p className="font-bold text-xl mb-1">"The best investment you can make is in yourself."</p>
                                <p className="text-black/80 text-sm">- Warren Buffett</p>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
